import { useState } from 'react';
import { useNavigate } from 'react-router';
import { FaArrowUp } from 'react-icons/fa';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import PratusSelect from 'components/DesignSystems/New/PratusSelect';
import CustomModal from 'components/DesignSystems/New/CustomModal';
import { useAdvanceOperationalPeriod } from 'hooks/incident/useIncidentManagement';
import { useSubscriptionLevel } from 'components/SubscriptionManagement/useSubscriptionLevel';
import {
  useAddIncidentCalendarEvent,
  eventTypes,
} from 'components/IAP/hooks/incidentCalendarHooks';
import { v7 } from 'uuid';
import { useIcs201Op0 } from 'hooks/incident/useIcs201Op0';
import { useIncident } from 'components/IAP/hooks/incidentHooks';

export const EscalateResponseButton = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const { data: incident } = useIncident();
  const advanceOperationalPeriodModal = useAdvanceOperationalPeriod();
  const { currentGroup } = useSubscriptionLevel();
  const mutation = useAddIncidentCalendarEvent();
  const { hasExported, exportIcs201Op0 } = useIcs201Op0(incident?.id);

  const createCalendarEvents = async () => {
    if (!incident) return;
    const events = eventTypes.filter((type) => type.title !== 'Other');
    for (let i = 0; i < events.length; i++) {
      mutation.mutateAsync({
        id: v7(),
        incidentId: incident.id,
        title: events[i].title,
        purpose: events[i].agenda,
        color: events[i].code,
        start: new Date(new Date().getTime() + i * 60 * 60 * 1000),
        end: new Date(new Date().getTime() + (i + 2) * 60 * 60 * 1000),
        location: 'TBD',
        externalAttendees: '',
        eventTypeLabel: events[i].title,
      });
    }
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleConfirm = () => {
    if (!incident) return;

    // Export ICS-201 if not already exported
    if (!hasExported) {
      exportIcs201Op0(false);
    }

    advanceOperationalPeriodModal.mutate(
      {
        incidentId: incident.id,
        anticipatedEndDateTime: null,
        groupGuid: currentGroup.group_guid,
      },
      {
        onSuccess: async () => {
          await createCalendarEvents();
          setShow(false);
          navigate(
            `/iap/${incident.id}/dashboard` +
              '?' +
              new URLSearchParams({
                period: '1',
                mode: 'future',
                phase: '1',
              }).toString()
          );
        },
      }
    );
  };

  if (!incident) return null;

  return (
    <>
      <StylishNewButton
        className="button--secondary gap-1 me-1"
        onClick={() => setShow(true)}
      >
        <SharedIcon iconName="arrow_upward" size="sm" />
        Escalate Response
      </StylishNewButton>
      <CustomModal
        show={show}
        heading="Escalate Response"
        onClose={handleClose}
        onConfirm={handleConfirm}
        saveButton="Escalate"
        icon={<FaArrowUp className="text-primary" size={20} />}
      >
        <p className="text-weak mb-5">
          Select a planning workflow to escalate the incident response level
        </p>
        <PratusSelect
          label="Planning Workflow"
          placeholder="Select a planning workflow"
          options={[
            {
              value: 'incident_command_system',
              label: 'Incident Command System',
            },
          ]}
          // Planning Workflow is not used anywhere right now.
          // It is strictly for sales to demo that new planning workflows can be created if needed by the customer.
          // onChange={() => {}}
        />
      </CustomModal>
    </>
  );
};
